<template>
  <FrontLayout>
    <!-- Main content will be rendered here -->
    <div class="main-content">
      <!-- Additional page content can go here -->
    </div>
  </FrontLayout>
</template>

<script>
import FrontLayout from '@/layouts/FrontLayout.vue'

export default {
  name: 'FrontHome',
  components: {
    FrontLayout
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
</style>
